import apiClient from '../../api/index';
import {
  DateRange,
  IKpiReportService,
  WaterfallResponse
} from './contracts/kpiReport.service';

export const KpiReportService: IKpiReportService = {
  async waterfallMetrics(
    machineId: number,
    dateRanges: DateRange[]
  ): Promise<WaterfallResponse> {
    const response = await apiClient.request('POST', '/kpi/waterfall', {
      where: {
        machineId,
        dateRanges
      }
    });
    return response as WaterfallResponse;
  }
};
